import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {InteractionRepository} from '../repositories/interaction.repository';

import {InteractionStatus} from '../model/model';

@Injectable()
export class InteractionService {

    constructor(public interactionRepository: InteractionRepository) { }

    public getInteractionStatus(): Observable<InteractionStatus> {
        return this.interactionRepository.getInteractionStatus();
    }

}
